export default "__VITE_ASSET__B9ZPIM19__"